//@flow
import React from 'react';
import {makeStyles, Typography} from '@material-ui/core';
import CustomTextField from '../../../../../../../elements/CustomTextField/CustomTextField';
import {useFormContext} from 'react-hook-form';
import {TRIGGER_FIELDS} from '../../const';
import {normalizeTriggerName} from '../../../../utils/adapters';
import {getFormError} from '../../../../utils/formErrors';
import {colors} from '../../../../../../../assets/styles/colors';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.75rem',
  },
  row: {
    display: 'flex',
    gap: '1rem',
    alignItems: 'stretch',
    flexWrap: 'wrap',
  },
  inputField: {
    flex: '1 1 240px',
  },
  previewCard: {
    flex: '0 1 220px',
    minWidth: '180px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '.35rem',
    padding: '.75rem 1rem',
    borderRadius: '12px',
    background: colors.grey100,
    border: `1px solid ${colors.grey300}`,
  },
  previewLabel: {
    fontSize: '.75rem',
    fontWeight: 600,
    color: colors.grey700,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
  },
  previewValue: {
    fontSize: '1rem',
    fontWeight: 700,
    color: colors.purple3,
    wordBreak: 'break-all',
    fontFamily: 'monospace',
  },
  previewPlaceholder: {
    fontSize: '.875rem',
    color: colors.grey600,
    fontStyle: 'italic',
  },
}));

const setValueOptions = {shouldDirty: true, shouldValidate: true};

export default function IdSection() {
  const classes = useStyles();
  const {register, errors, setValue, watch} = useFormContext();

  const rawValue = watch(TRIGGER_FIELDS.id, '');
  const computedName = normalizeTriggerName(rawValue);
  const hasComputedName = computedName.length > 0;
  const isValidComputed = hasComputedName && /^[a-z0-9_]+$/i.test(computedName);
  const idErrorMessage = getFormError(errors, TRIGGER_FIELDS.id);

  const handleNameChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    setValue(TRIGGER_FIELDS.id, event.target.value, setValueOptions);
  };

  const showError =
    !!idErrorMessage || (rawValue.length > 0 && !isValidComputed);

  const helperText =
    idErrorMessage ||
    (rawValue.length > 0 && !isValidComputed
      ? 'El identificador guardado solo puede tener letras, números y guiones bajos'
      : 'Escribe con espacios si quieres. A la derecha ves cómo quedará guardado.');

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <CustomTextField
          className={classes.inputField}
          name={TRIGGER_FIELDS.id}
          label="Nombre"
          placeholder="bienvenida 1"
          value={rawValue}
          inputRef={register({
            required: 'El identificador es requerido',
          })}
          onChange={handleNameChange}
          error={showError}
          helperText={helperText}
        />

        <div className={classes.previewCard}>
          <Typography className={classes.previewLabel}>
            Se guardará como
          </Typography>
          {hasComputedName ? (
            <Typography className={classes.previewValue}>
              {computedName}
            </Typography>
          ) : (
            <Typography className={classes.previewPlaceholder}>
              bienvenida_1
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
}
